import { QRCodeSVG } from "qrcode.react";

export default function RegistrationQr() {
  const qrUrl = "https://jinraitech.com/contact-card/create-account";

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white p-6 mt-1">
      {/* Card */}
      <div className="relative bg-gradient-to-br from-[#bf98ce] to-[#8f77c6] rounded-2xl shadow-lg text-center w-full max-w-sm pt-16 pb-8 px-6">

        {/* Heading */}
        <h2 className="text-[20px] font-bold text-white">Contact Card Create</h2>
        <p className="text-sm text-white/80 mb-6">Scan this QR to create your contact card</p>

        {/* QR Code box */}
        <div className="bg-white rounded-xl p-4 shadow-md inline-block">
          <QRCodeSVG value={qrUrl} size={200} />
        </div>
      </div>

      {/* Bottom Button */}
      <button className="mt-4 w-full max-w-sm py-3 bg-[#7f6bc6] text-white rounded-xl shadow-md hover:opacity-90 transition font-bold">
        Scan Code
      </button>
    </div>
  );
}
